import { FileTextOutlined, ReadOutlined, RocketOutlined, TeamOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import React, { isValidElement } from 'react'
import { useTranslation } from 'react-i18next'

import { UserCardUsageFragment } from '@/generated/graphql'

interface UserHoverCardProps {
  email: string
}
export const UserTaleUsage = ({ user }: { user: UserCardUsageFragment }) => {
  const { t } = useTranslation()

  return (
    <>
      {user.featuredPosts.totalCount > 0 && (
        <div>
          <Tooltip title={t('userCard.featured')}>
            <RocketOutlined />
            <span>{user.featuredPosts.totalCount}</span>
          </Tooltip>
        </div>
      )}
      {user.contributedKnowledge && user.contributedKnowledge.totalCount > 0 && (
        <div>
          <Tooltip title={t('userCard.contributedKnowledge')}>
            <ReadOutlined />
            <span>{user.contributedKnowledge.totalCount}</span>
          </Tooltip>
        </div>
      )}
      <div>
        <Tooltip title={t('userCard.followedUsers')}>
          <TeamOutlined />
          <span>{user.followedUsers.totalCount}</span>
        </Tooltip>
      </div>
      <div>
        <Tooltip title={t('userCard.createdPosts')}>
          <FileTextOutlined />
          <span>{user.createdPosts.totalCount}</span>
        </Tooltip>
      </div>
    </>
  )
}

export const UserHoverCard: React.FC<UserHoverCardProps> = ({ email, children }) => {
  return React.cloneElement(isValidElement(children) ? children : <span>{children}</span>, {
    'enterprise-user-card': email,
  })
}
